import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
    "https://tewgjrabqdtnkdyvuzbb.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRld2dqcmFicWR0bmtkeXZ1emJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTMwNjM3NzQsImV4cCI6MjAwODYzOTc3NH0.WETDi52XWq9E9Flmu4GluQiWzWSd_K87R_Mc43yU0EY"
);